import { createAction, emptyProps, props } from '@ngrx/store';
import { IWorkspace } from './workspaces-model';

export enum ActionTypes {
  GET_WORKSPACES = '[GET_WORKSPACES] Request',
  GET_WORKSPACES_SUCCESS = '[GET_WORKSPACES] Success',
  GET_WORKSPACES_FAILURE = '[GET_WORKSPACES] Failure',

  GET_WORKSPACES_INVITES = '[GET_WORKSPACES_INVITES] Request',
  GET_WORKSPACES_INVITES_SUCCESS = '[GET_WORKSPACES_INVITES] Success',
  GET_WORKSPACES_INVITES_FAILURE = '[GET_WORKSPACES_INVITES] Failure',

  DELETE_WORKSPACE = '[DELETE_WORKSPACE] Request',
  DELETE_WORKSPACE_SUCCESS = '[DELETE_WORKSPACE] Success',
  DELETE_WORKSPACE_FAILURE = '[DELETE_WORKSPACE] Failure',

  UPDATE_WORKSPACES_INVITES = '[UPDATE_WORKSPACES_INVITES] Request',
  UPDATE_WORKSPACES_INVITES_SUCCESS = '[UPDATE_WORKSPACES_INVITES] Success',
  UPDATE_WORKSPACES_INVITES_FAILURE = '[UPDATE_WORKSPACES_INVITES] Failure',
  RESET_WORKSPACES_INVITES = '[RESET_WORKSPACES_INVITES] Request',

  GET_WORKSPACE_VAULT_CONFIG = '[GET_WORKSPACE_VAULT_CONFIG] Request',
  GET_WORKSPACE_VAULT_CONFIG_SUCCESS = '[GET_WORKSPACE_VAULT_CONFIG] Success',
  GET_WORKSPACE_VAULT_CONFIG_FAILURE = '[GET_WORKSPACE_VAULT_CONFIG] Failure',

  DELETE_WORKSPACE_VAULT_CONFIG = '[DELETE_WORKSPACE_VAULT_CONFIG] Request',
  DELETE_WORKSPACE_VAULT_CONFIG_SUCCESS = '[DELETE_WORKSPACE_VAULT_CONFIG] Success',
  DELETE_WORKSPACE_VAULT_CONFIG_FAILURE = '[DELETE_WORKSPACE_VAULT_CONFIG] Failure',
}

export const getWorkspacesRequest = createAction(ActionTypes.GET_WORKSPACES);

export const getWorkspacesSuccess = createAction(ActionTypes.GET_WORKSPACES_SUCCESS, props<{ payload: IWorkspace[] }>());

export const getWorkspacesFailure = createAction(ActionTypes.GET_WORKSPACES_FAILURE, props<{ error: string }>());

export const getWorkspacesInvitesRequest = createAction(ActionTypes.GET_WORKSPACES_INVITES);

export const getWorkspacesInvitesSuccess = createAction(ActionTypes.GET_WORKSPACES_INVITES_SUCCESS, props<{ payload: any }>());

export const getWorkspacesInvitesFailure = createAction(ActionTypes.GET_WORKSPACES_INVITES_FAILURE, props<{ error: string }>());

export const deleteWorkspaceRequest = createAction(ActionTypes.DELETE_WORKSPACE, props<{ workspaceId: string }>());

export const deleteWorkspaceSuccess = createAction(ActionTypes.DELETE_WORKSPACE_SUCCESS, props<{ workspaceId: string }>());

export const deleteWorkspaceFailure = createAction(ActionTypes.DELETE_WORKSPACE_FAILURE, props<{ error: string }>());

export const updateWorkspacesInvitesRequest = createAction(
  ActionTypes.UPDATE_WORKSPACES_INVITES,
  props<{
    workspace_id: string;
    invite_response: 'accept' | 'decline';
  }>()
);

export const updateWorkspacesInvitesSuccess = createAction(ActionTypes.UPDATE_WORKSPACES_INVITES_SUCCESS, props<{ payload: any }>());

export const updateWorkspacesInvitesFailure = createAction(ActionTypes.UPDATE_WORKSPACES_INVITES_FAILURE, props<{ error: string }>());
export const resetWorkspacesInvitesRequest = createAction(ActionTypes.RESET_WORKSPACES_INVITES);

// Union of actions for use in reducers
export type Actions =
  | ReturnType<typeof getWorkspacesRequest>
  | ReturnType<typeof getWorkspacesSuccess>
  | ReturnType<typeof getWorkspacesFailure>
  | ReturnType<typeof getWorkspacesInvitesRequest>
  | ReturnType<typeof getWorkspacesInvitesSuccess>
  | ReturnType<typeof getWorkspacesInvitesFailure>
  | ReturnType<typeof deleteWorkspaceRequest>
  | ReturnType<typeof deleteWorkspaceSuccess>
  | ReturnType<typeof deleteWorkspaceFailure>
  | ReturnType<typeof updateWorkspacesInvitesRequest>
  | ReturnType<typeof updateWorkspacesInvitesSuccess>
  | ReturnType<typeof updateWorkspacesInvitesFailure>
  | ReturnType<typeof resetWorkspacesInvitesRequest>;
